import React, { useState, useEffect } from "react";
import { AdjustmentsVerticalIcon, CalendarDaysIcon } from "@heroicons/react/24/outline";
import DatePicker from "react-tailwindcss-datepicker";
import AdminInvoiceTable from "./tables/AdminInvoiceTable";
import InvoicesDropDownFilter from "./InvoicesDropdownFilter";
import {
  useGetAllInvoicesQuery,
  useLazyGetAllInvoicesQuery,
  useLazyGetFilteredInvoicesQuery,
} from "../../../../store/admin/invoices";
import Loader from "../../../commons/Loader";
import moment from "moment";
import SkeletonTable from "../../../commons/Skeleton/SkeletonTable";

const DashboardAdminInvoicePage = () => {
  const [filterActive, setFilterActive] = useState(false);
  const [allInvoicesData, setAllInvoicesData] = useState();
  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });

  const { data: allInvoices, isLoading: allInvoicesLoader } =
    useGetAllInvoicesQuery();

  const [refetch, { data, isLoading: allInvoicesRefetchLoader, isFetching }] =
    useLazyGetAllInvoicesQuery();

  const [
    getAllFilteredInvoices,
    {
      data: filteredInvoices,
      isLoading: filteredInvoicesLoader,
      isFetching: isFetchingFilteredInvoices,
    },
  ] = useLazyGetFilteredInvoicesQuery();

  useEffect(() => {
    if (filteredInvoices) {
      setAllInvoicesData(filteredInvoices);
    }
  }, [filteredInvoices]);

  useEffect(() => {
    if (allInvoices) {
      setAllInvoicesData(allInvoices);
    }
  }, [allInvoices]);

  useEffect(() => {
    if (data) {
      setAllInvoicesData(data);
    }
  }, [data]);

  const handleValueChange = (newValue) => {
    getAllFilteredInvoices({
      startDate: newValue.startDate,
      endDate: newValue.endDate,
      // status_ids: selectedStatus.map((status) => status.id).join(","),
    });
    setValue(newValue);
  };

  const handleInvoicesFilter = () => {
    setFilterActive((prevState) => !prevState);
  };

  // if (filteredInvoicesLoader || allInvoicesLoader)
  //   return <SkeletonTable col={8} rows={8} />;

  return (
    <div className="col-span-12">
      <div className="flex justify-between items-start md:items-center flex-col md:flex-row gap-5 mb-5">
        <h3 className="text-xl leading-[160%] font-bold text-[#04091E]">
          Invoices
        </h3>
        <div className="flex items-start md:items-center gap-3.5 md:gap-[30px] flex-col md:flex-row md:max-w-[360px] justify-end w-full">
        <div className="rounded-md custom-date-picker cdp-new flex items-center md:max-w-[320px] w-full border border-[#ebeff3] bg-white py-2 h-12 cursor-pointer relative z-[1]">
            <div className="pr-3 mr-3 border-r border-[#EBEFF3] absolute left-5 -z-[1]">
              <CalendarDaysIcon className="w-6 h-6" />
            </div>
            <DatePicker
              primaryColor={"blue"}
              value={value}
              toggleClassName="hidden"
              onChange={handleValueChange}
              displayFormat={"MM/DD/YYYY"}
              showShortcuts={true}
              useRange={false}
              maxDate={moment().toDate()}
              readOnly
            />
          </div>
          {/* <div className="relative w-full md:w-auto">
            <button
              className={`w-full md:w-12 h-12 flex items-center justify-center gap-2.5 md:gap-0 rounded-[10px] ${
                filterActive
                  ? "bg-[#D2ECFF] text-primary"
                  : "bg-[#EBEFF3] text-[#485868]"
              }`}
              onClick={handleInvoicesFilter}
            >
              <AdjustmentsVerticalIcon className="w-6 h-6 text-[#485868]" />
              <span
                className={`text-sm font-bold leading-[160%] text-[#485868] block md:hidden ${
                  filterActive ? "text-primary" : "text-[#485868]"
                }`}
              >
                Filter
              </span>
            </button>
            <div
              className={`notificationDropdown absolute right-0 top-[55px] md:top-[60px] z-10 opacity-0 ${
                filterActive ? "notificationOpen" : ""
              }`}
            >
              <InvoicesDropDownFilter
                setFilterActive={setFilterActive}
                filterActive={filterActive}
              />
            </div>
          </div> */}
        </div>
      </div>
      {/* {allInvoicesData && ( */}
      <AdminInvoiceTable
        invoices={allInvoicesData}
        getUpdateData={(page, perPage) => {
          getAllFilteredInvoices({
            page,
            perPage,
            startDate: value.startDate,
            endDate: value.endDate,
            // status_ids: selectedStatus.map((status) => status.id).join(","),
          });
        }}
      />
      {/* )} */}
    </div>
  );
};

export default DashboardAdminInvoicePage;
